import * as yup from "yup";

import { combinedPhoneNumberValidator } from "../../../../../components/phone-number-input/validators";

const formSchema = yup.object().shape({
  mobilePhone: combinedPhoneNumberValidator,
});

export default formSchema;
